<template>
  <div class="mybankcard">
    <div class="fr ac jsb mb20">
      <p>我的银行卡</p>
      <el-button type="text" size="mini" @click="show_add = true">添加银行卡</el-button>
    </div>
    <div class="main">
      <el-table :data="cart_list" style="width: 100%">
        <el-table-column label="银行卡">
          <template slot-scope="scope">
            <p class>{{ scope.row.bank_name }}</p>
            <p class="mt10">{{ formatBankCard(scope.row.bank_no) }}</p>
          </template>
        </el-table-column>
        <el-table-column
            prop="create_time"
            label="绑定时间"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button
                type="text"
                size="small"
                @click="deleteMemberBank(scope.row.bank_id)"
            >解除绑定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fr ac jc">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page.sync="page"
            class="mt20 mb20"
            :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <re-dialog :visible.sync="show_add" title="添加银行卡">
      <add-bank-card @success="show_add = false;getMemberBanks();"/>
    </re-dialog>
  </div>
</template>

<script>
import add from "./add"

export default {
  data() {
    return {
      page: 1,
      total: 0,
      show_add: false,
      cart_list: []
    };
  },
  watch: {
    page(n) {
      this.getMemberBanks();
    }
  },
  created() {
    this.getMemberBanks();
  },
  methods: {
    deleteMemberBank(id) {
      this.$confirm("此操作将解绑该银行卡, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("bankInterfaces/v1.0/deleteMemberBank", {
              bank_ids: id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已解绑银行卡"
              });
              this.getMemberBanks();
            });
          })
          .catch(() => {
          });
    },
    getMemberBanks() {
      this.post("bankInterfaces/v1.0/getMemberBanks", {
        page: this.page
      }).then(res => {
        this.cart_list = res.data;
        this.total = res.total;
      });
    }
  },
  components: {"add-bank-card": add}
};
</script>

<style scoped lang="scss">
.mybankcard {
  font-size: 14px;

  .main {
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/BankCard/index.vue